import React from 'react'
import { Container } from '@material-ui/core';


import './footer.css';

const Footer = () => {
    return (
        <div id='footer'>
            <Container>
                <h3>&copy; Copyright 2020, JE Sutton LLC</h3>
            </Container>
        </div>
    )
}

export default Footer;
